import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react"
import { Form, Row, Col, Select } from 'antd';
import Input from '../../../../../ui/Input';
import TextArea from '../../../../../ui/TextArea';
import ActionButtonsBar from '../../../../../ui/ActionButtonsBar';
import { getOTACodes } from '../../../../../../services/common'
import styles from '../../../index.module.css'
const { Option } = Select;
const RoomDetailAdd = forwardRef((props: any, detailAddRef: any) => {
    const [form] = Form.useForm()
    const [uomData, setUomData] = useState<any>([])
    const [disabledSave, setDisableSave] = useState<boolean>(true)
    useImperativeHandle(detailAddRef, () => ({ detailsForm: form }))
    useEffect(() => {
        getUomData()
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps 
    [])
    useEffect(() => {
        props.validateFieldsError(); 
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [uomData])
    const getUomData = async () => {
        let res = await getOTACodes('UOM', 'Area')
        if (res && res.otacodes && res.otacodes.length != 0) {
            setUomData(res.otacodes)
        } else {
            setUomData([])
        }
    };
    const SaveClick = async () => {
        props.addSave()
        props.setMeetingroomTabsActivityKey('2')
    }

    useEffect(() => {
        form.resetFields()
        setDisableSave(true)
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

    return (
      <div className={styles.addCon}>
        <Form
          layout='vertical'
          form={form}
          name='basic'
          onValuesChange={(changedFields, allFields) => {
            form.validateFields()
              .then()
              .catch(e => {
                if (e?.errorFields.length > 0) {
                  setDisableSave(true)
                } else {
                  setDisableSave(false)
                }
              })
          }}>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Room Id'
                name='id'
                rules={[
                  {
                    max: 32,
                    message: 'You have reached the max character length of 32',
                  },
                ]}>
                <Input maxLength={32} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Room Name'
                name='name'
                rules={[
                  { required: true, message: 'This field is required' },
                  {
                    max: 128,
                    message: 'You have reached the max character length of 128',
                  },
                ]}>
                <Input maxLength={128} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                extra={
                  <span className={styles.tipColor}>
                    Please input Total Area in Square feet
                  </span>
                }
                label='Total Space'
                name='area'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Length'
                name='length'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Width'
                name='width'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Height'
                name='height'
                rules={[
                  {
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item label='Unit of Measure' name='uom'>
                <Select allowClear showSearch>
                  {uomData.map((item: any, index: any) => {
                    return (
                      <Option key={index} value={item.codeName}>
                        {item.codeName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                extra={
                  <span className={styles.tipColor}>
                    Please input Rank as 1, 2, 3, etc… for each Meeting Room
                  </span>
                }
                label='Rank'
                name='rank'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
            <Form.Item 
              label='Room Decor' 
              name='decor'
              rules={[
                {
                  max: 40,
                  message: 'You have reached the max character length of 40',
                }]}     
              >
                 <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Minimum Charge'
                name='mincharge'
                rules={[
                  {
                    required: false,
                    pattern: /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/,
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Number of 10x10 Exhibits'
                name='tenbytenexhibit'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Open Square Capacity'
                name='onesquarecapacity'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={6}>
              <Form.Item
                label='Other Capacity'
                name='othercapacity'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item
                label='Largest Capacity'
                name='largestcapacity'
                rules={[
                  {
                    required: false,
                    pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                    message: 'This field should be a number',
                  },
                ]}>
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={24}>
            <Col span={18}>
              <Form.Item
                label='Description'
                name='description'
                extra={
                  <span className={styles.tipColor}>
                    Lanyon allows 300 characters
                  </span>
                }
                rules={[
                  {
                    max: 300,
                    message: 'You have reached the max character length of 300',
                  },
                ]}>
                <TextArea maxLength={300} maxRows={3} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
        <ActionButtonsBar
          onCancel={() => {
            props.setCurrentOneNav('orign')
            window.cancelEdition()
            props.setMeetingroomTabsActivityKey('2')
          }}
          onSave={SaveClick}
          disabledSave={disabledSave}
          alertMsg={true}
          message={"Please complete the Detail section and save which will enable the Capacity and Service pages"}
        />
      </div>
    )
})

export default RoomDetailAdd
